import Title from "@/shared/components/Title/Title";
import { TextField } from "@mui/material";
import ServicesHeaderSelector from "../ServicesHeaderSelector/ServicesHeaderSelector";

import { IServicesControlsProps } from "@/shared/interfaces/schedulePage";

import { inputStyles, inputSearchInHeader } from "@/utils/constants";

export default function ServicesHeader({
    category,
    handleChange,
    query,
    handleChangeCategory = () => {},
    data,
    toggleDrawer,
}: IServicesControlsProps) {
    return (
        <header className='header_in_content_component header_in_patiens_page'>
            <Title tag='h2' text={"Послуги"} />
            <Title
                tag='h3'
                text={`(${data.length.toString()})`}
                style={{
                    color: "#909DAD",
                }}
            />
            <div className='header_input_container'>
                <img
                    src='/patients/search.svg'
                    alt='logo search'
                    className='header_input_container_logo'
                />
                <TextField
                    placeholder='Пошук'
                    value={query}
                    onChange={handleChange}
                    sx={{
                        ...inputStyles.root,
                        ...inputSearchInHeader.root,
                    }}
                />
            </div>
            <ServicesHeaderSelector
                category={category ? category : "Всі категорії"}
                handleChangeCategory={handleChangeCategory}
            />
            <button
                className='header_input_add_button'
                onClick={() => toggleDrawer?.(true)}
            >
                <img
                    className='header_input_add_icon'
                    src='/patients/plus.svg'
                    alt='logo plus'
                />
                Додати послугу
            </button>
        </header>
    );
}
